module.exports = __webpack_public_path__ + "static/media/chat-icon.2387380d.svg";